<template>
   <div class="app-testimonials">
		<carousel  :speed="2000" :perPage="1" :loop="true" :autoplay="false" :navication-enabled="true" :pagination-enabled="true" :pagination-size="15" pagination-active-color="#c51b1e" pagination-color="#717c7e">
			<slide v-for="testimonial in testimonials">
				<section class="app-testimonials__wrapper">
					<p class="text app-testimonials__quote">{{ testimonial.text }}</p>
					<img :src="require('@/assets/testimonials/' + testimonial.image)" alt="" class="app-testimonials__image"/>
					<div class="app-testimonials__detail">
						<p class="text app-testimonials__text app-testimonials__name">{{ testimonial.name }}</p>
						<p class="text app-testimonials__text">{{ testimonial.title }}</p>
					</div>
				</section>
			</slide>
		</carousel>
   </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
   components: {
      Carousel,
      Slide,
   },
   data () {
      return {

      }
	},
	props:{
		testimonials: Array
	}
}
</script>

<style scoped>
.app-testimonials { text-align: center; display: flex; flex-direction: column; }
.app-testimonials__wrapper { display: flex; flex-wrap: wrap; align-items: flex-start; justify-content: center; max-width: 875px; margin: 0 auto; }
.app-testimonials__image { border-radius: 50%; width: 200px; overflow: hidden; order: 1; }
.app-testimonials__detail { order: 3; }
.app-testimonials__quote { padding: 20px 0; margin-left:auto; margin-right: auto; position: relative; order: 2; }
.app-testimonials__quote::before { background: url('./../../assets/quote-left.svg'); bottom: 900%; right: 100%; }
.app-testimonials__quote::after { background: url('./../../assets/quote-right.svg'); top:90%; left: 100%; }
.app-testimonials__quote::before, .app-testimonials__quote::after { content: " "; background-size: contain; background-repeat: no-repeat; width: 75px; height: 75px; position: absolute; }
.app-testimonials__name { color: #c51b1e; font-weight: bold; }
.app-testimonials__text { margin:0; }

@media (max-width: 900px) {
	.app-testimonials__quote::before { right: calc(100% - 75px); }
	.app-testimonials__quote::after { left: calc(100% - 75px); }
}
</style>
